import { ItemList } from '../../orm'

class AdminVoxboneIncomingFaxList extends ItemList {
    getEntityKey() {
        return "voxbone/incoming_fax"
    }
}

export const adminVoxboneIncomingFaxList = new AdminVoxboneIncomingFaxList("admin_voxbone_incoming_faxes__default")
